import { CalendarDays } from 'lucide-react';

export default function DataUnavailableBanner() {
  return (
    <div className="flex flex-col items-center gap-3 rounded-2xl border border-dashed border-slate-900/[0.08] bg-white px-6 py-8 text-center shadow-[0_1px_2px_rgba(15,23,42,0.03),0_12px_32px_-20px_rgba(15,23,42,0.12)]">
      <div className="flex size-11 items-center justify-center rounded-full bg-[#E6D5B8]/55 text-[#8A6F45] shadow-sm">
        <CalendarDays className="size-5" aria-hidden />
      </div>
      <div className="space-y-1">
        <p className="text-sm font-semibold text-slate-800">No calendar data yet</p>
        <p className="max-w-sm text-xs leading-relaxed text-slate-500">
          Earnings data updates weekly after the sync runs. Check back soon for upcoming reports.
        </p>
      </div>
    </div>
  );
}
